import type { RootStateOrAny } from 'react-redux'
import { useSelector } from 'react-redux'

export const useLocation = () =>
  useSelector((state: RootStateOrAny) => state.routing.locationBeforeTransitions)
